<template>
  <v-card-text class="pa-0">
    <v-toolbar
      height="50"
      dark
      class="pointer ou-toolbar"
      v-ripple
      @click="toggleItem"
    >
      <v-toolbar-title class="ou-toolbar-text text-black">{{ item.name }}</v-toolbar-title>
    </v-toolbar>
    <v-row
      class="ma-0"
      v-if="item.opened"
    >
      <setup-checklist-tasks-list
        v-for="(task, index) in item.tasks"
        :key="index"
        :task="task"
        @toggleTaskSelected="toggleTaskSelected"
      />
    </v-row>
  </v-card-text>
</template>

<script>
  import SetupChecklistTasksList from './SetupChecklistTasksList'
  export default {
    name: 'GettindStartedItemsList',
    components: {
      SetupChecklistTasksList
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      toggleTaskSelected (task) {
        this.$emit('toggleTaskSelected', task)
      },
      toggleItem () {
        this.$emit('toggleItem', this.item.name)
      }
    }
  }
</script>
